
import React from "react";
import { Button } from "@/components/ui/button";
import VerificationInput from "react-verification-input";

interface VerificationFormProps {
  verificationCode: string;
  loading: boolean;
  onVerificationCodeChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const VerificationForm = ({
  verificationCode,
  loading,
  onVerificationCodeChange,
  onSubmit,
}: VerificationFormProps) => {
  return (
    <form onSubmit={onSubmit} className="mt-8 space-y-6 w-full">
      <div className="space-y-2 flex flex-col items-center">
        <label htmlFor="otp" className="block text-sm font-medium text-card-foreground text-center">
          Enter Verification Code
        </label>
        <div className="flex justify-center w-full">
          <VerificationInput
            value={verificationCode}
            onChange={onVerificationCodeChange}
            length={6}
            placeholder=""
            autoFocus
            classNames={{
              container: "container",
              character: "w-10 h-12 text-lg bg-background border border-border text-foreground focus:border-primary focus:ring-primary rounded-md flex items-center justify-center transition-all duration-200",
              characterInactive: "character--inactive",
              characterSelected: "ring-2 ring-primary ring-offset-1 z-10",
            }}
          />
        </div>
      </div>

      <Button
        type="submit"
        className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
        disabled={loading || verificationCode.length !== 6}
      >
        {loading ? "Verifying..." : "Verify Code"}
      </Button>
    </form>
  );
};
